/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  workbench.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:31
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

  /* 担保函 */
 const guaranteeRouter = [
  {
    path: "/fileList",
    name: "FileList",
    component: () =>
        import(/* webpackChunkName: "fileList" */ "@/views/guarantee/fileList.vue"),
    meta: {
      title: "文件列表",
      keepAlive: true,
      deepth: 1
    },
  },
  {
    path: "/guaranteeFace",
    name: "GuaranteeFace",
    component: () =>
            import(/* webpackChunkName: "guaranteeFace" */ "@/views/guarantee/guaranteeFace.vue"),
    meta: {
      title: "人脸识别",
      keepAlive: true,
      deepth:1
    },
  },
  {
    path: "/guaranteeResult",
    name: "GuaranteeResult",
    component: () =>
            import(/* webpackChunkName: "guaranteeResult" */ "@/views/guarantee/guaranteeResult.vue"),
    meta: {
      title: "识别结果",
      keepAlive: true,
      deepth:1
    },
  },
  {
    path: "/guaranteeInfo",
    name: "GuaranteeInfo",
    component: () =>
            import(/* webpackChunkName: "guaranteeInfo" */ "@/views/guarantee/guaranteeInfo.vue"),
    meta: {
      title: "担保函详情",
      keepAlive: true,
      deepth:1
    },
  },
  {
    path: "/guaranteeDetail",
    name: "GuaranteeDetail",
    component: () =>
            import(/* webpackChunkName: "guaranteeDetail" */ "@/views/guarantee/guaranteeDetail.vue"),
    meta: {
      title: "担保函明细",
      keepAlive: true,
      deepth:1
    },
  },
  {
    path: "/guaranteeSuccess",
    name: "GuaranteeSuccess",
    component: () =>
            import(/* webpackChunkName: "guaranteeSuccess" */ "@/views/guarantee/guaranteeSuccess.vue"),
    meta: {
      title: "签署结果",
      keepAlive: true,
      deepth:1
    },
  },
]

export default guaranteeRouter
